module.exports = __webpack_public_path__ + "static/media/engagement-qa.31b5dec3.svg";


//////////////////
// WEBPACK FOOTER
// ./src/shared/assets/engagement-qa.svg
// module id = 382
// module chunks = 0